module.exports = __webpack_public_path__ + "img/chairs-kitchen-pc.fa51f17a.png";